import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpRequest, HttpHandler, HttpErrorResponse, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthenticationService } from './authentication.service';

/**
 * This class is the the http request interceptor that checks for authorization failure and if it occurs,
 * redirects to the login page
 */
@Injectable()
export class AuthInterceptor implements HttpInterceptor {

	/**
	 * Constructor for AuthInterceptor
	 * @param _authService The authentication service used for managing authentication state
	 * @param _router The router used for redirecting to a page.
	 */
	constructor(private _authService: AuthenticationService, private _router: Router) {
	}

	/**
	 * HTTP request intercept method.
	 *
	 * @param Request The HTTP request about to be sent.
	 * @param Next The next interceptor in the chain.
	 */
	public intercept(Request: HttpRequest<any>, Next: HttpHandler): Observable<HttpEvent<any>> {
		return Next.handle(Request)
			.pipe(
				catchError((error: any) => {
					if (error instanceof HttpErrorResponse) {
						if (error.status === 401) {
							this._authService.Deauthenticate();
							console.log("AuthInterceptor - 401 error - Redirect to login");
							this._router.navigate(["/login"]);
						}
					}
					return throwError(error);
				})
			);
	}
}
